/**
 * The Pet Treats' pictures (Pets v2, docs/PETS.md): a bone-shaped biscuit drawn as inline SVG until painted icons land
 * (art/interface has none yet) — the plain one baked brown, the Golden one gilt with a glint, the Royal one in plum
 * with a little gold crown. Markup, so it sits in a k-well (components.ts wellHtml's `art`) or a chip as is.
 */

interface TreatLook { readonly fill: string; readonly edge: string; readonly dots: string; readonly glint: boolean; readonly crown: boolean }

const LOOKS: Readonly<Record<string, TreatLook>> = {
  biscuit: { fill: "#e0a85e", edge: "#8f5a22", dots: "#a86c2c", glint: false, crown: false },
  goldenBiscuit: { fill: "#ffd75c", edge: "#a87410", dots: "#d29a1e", glint: true, crown: false },
  royalBiscuit: { fill: "#c39bff", edge: "#5d3399", dots: "#8a5fd0", glint: true, crown: true },
};
const PLAIN = LOOKS.biscuit;

/** The bone (a 64 × 64 box, laid flat): a bar with two round knobs at each end. */
const BONE = `<rect x="16" y="28" width="32" height="10" rx="2"/><circle cx="16" cy="27" r="7"/><circle cx="16" cy="39" r="7"/><circle cx="48" cy="27" r="7"/><circle cx="48" cy="39" r="7"/>`;
const CROWN = `<path d="M24 14l4-8 4 6 4-6 4 8z" fill="#ffd75c" stroke="#a87410" stroke-width="1.5" stroke-linejoin="round"/>`;
const GLINT = `<path d="M47 12l1.6 4 4 1.6-4 1.6-1.6 4-1.6-4-4-1.6 4-1.6z" fill="#fff"/>`;

/** Treat `id`'s picture at `px` CSS px (an unknown id: the plain biscuit). */
export function treatArtHtml(id: string, px: number): string {
  const L = LOOKS[id] ?? PLAIN;
  // the outline is the same shapes drawn fatter in the edge colour underneath, so the knobs and the bar read as one
  return `<svg class="treatart" width="${px}" height="${px}" viewBox="0 0 64 64" aria-hidden="true"><g transform="rotate(-28 32 33)">`
    + `<g fill="rgba(0,0,0,.28)" transform="translate(0 4)">${BONE}</g>`
    + `<g fill="${L.edge}" stroke="${L.edge}" stroke-width="6">${BONE}</g><g fill="${L.fill}">${BONE}</g>`
    + `<circle cx="27" cy="33" r="1.8" fill="${L.dots}"/><circle cx="33" cy="31" r="1.8" fill="${L.dots}"/><circle cx="39" cy="34" r="1.8" fill="${L.dots}"/></g>`
    + (L.crown ? CROWN : "") + (L.glint ? GLINT : "") + `</svg>`;
}
